module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "size": "mini",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账单生成时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "placeholder": "选择日期",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "clearable": _vm.clearable,
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), (_vm.$store.getters.type != 1) ? _c('el-form-item', {
    attrs: {
      "label": "学校",
      "prop": "schoolId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "schoolId", $$v)
      },
      expression: "queryForm.schoolId"
    }
  }, _vm._l((_vm.schoolOptions), function(item) {
    return _c('el-option', {
      key: item.school_id,
      attrs: {
        "label": item.school_name,
        "value": item.school_id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "pb10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.printPDF
    }
  }, [_vm._v("打印")])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card mb20",
    staticStyle: {
      "background-color": "#eaf5fc"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', [_vm._v("订单数量总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.orderCount) + "单")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', [_vm._v("退单数量总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.refundCount) + "单")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', [_vm._v("配送费总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.deliveryFeeTotalAmount) + "元")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', [_vm._v("应付款项")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.payTotalAmount) + "元")])])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pb10"
  }, [_c('export-excel', {
    attrs: {
      "params": _vm.exportParams,
      "action": _vm.$apiUrl.financeSchoolBill,
      "target": 'finance',
      "field": _vm.field,
      "filename": _vm.fileName,
      "fieldname": _vm.fieldName,
      "method": "post"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "primary f12 pt10"
  }, [_vm._v("应付款项：包含加价、佣金、配送费、环保费、服务费")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "scheduleBillCode",
      "label": "账单编号",
      "show-overflow-tooltip": true,
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkoutCommercialName",
      "label": "商户名称",
      "show-overflow-tooltip": true,
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expectPayDate",
      "label": "生成时间",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startDate",
      "label": "开始时间",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endDate",
      "label": "结束时间",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderSum",
      "label": "订单数量",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refundSum",
      "label": "退单数量",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deliveryFee",
      "label": "配送费",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceFee",
      "label": "服务费",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "billAmount",
      "label": "应付款项",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "billStatus",
      "label": "状态",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.billStatus == 0) ? _c('span', [_vm._v("未打款")]) : _vm._e(), _vm._v(" "), (scope.row.billStatus == 1) ? _c('span', [_vm._v("调起自动付款")]) : _vm._e(), _vm._v(" "), (scope.row.billStatus == 2) ? _c('span', [_vm._v("付款成功")]) : _vm._e(), _vm._v(" "), (scope.row.billStatus == 3) ? _c('span', [_vm._v("付款失败")]) : _vm._e(), _vm._v(" "), (scope.row.billStatus == 8) ? _c('span', [_vm._v("无需打款")]) : _vm._e(), _vm._v(" "), (scope.row.billStatus == 9) ? _c('span', [_vm._v("冻结")]) : _vm._e()]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0139f44e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/finance/schoolBill.vue
// module id = 842
// module chunks = 0